import { Transition } from "../../../core/flows/Transition";
import { OffersContext } from "../Context/OffersContext";

export class OfferTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<OffersContext>("offersContext", this.entryStep)!

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }
}
